module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av129-eb09ad9a6efc68ce0d3dd6d6bb27cb09.jpg";